"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestSpaceSchema = void 0;
/**
 *  The validation schema for a request space.
 */
exports.RequestSpaceSchema = {
    $id: '#request-space',
    type: 'object',
    additionalProperties: false,
    /**
     *  Default required properties,
     */
    required: [
        'tool_space_id',
        'name',
        'floor',
        'insulation_level',
        'outdoor_unit_location',
        'contents',
    ],
    /**
     *  The properties.
     */
    properties: {
        tool_space_id: { type: 'string', pattern: "[a-zA-Z0-9]", },
        name: { type: 'string', minLength: 4, maxLength: 20, pattern: "[a-z\u00C0-\u00FF ]", },
        floor: { type: 'string' },
        floor_description: { type: ['string', 'null'] },
        insulation_level: { type: 'string' },
        outdoor_unit_location: { type: 'string' },
        length: { type: ['number', 'null'], minimum: 1 },
        width: { type: ['number', 'null'], minimum: 1 },
        height: { type: ['number', 'null'], minimum: 1 },
        contents: { type: 'number', minimum: 1 },
        with_outer_wall: { type: 'number', enum: [0, 1] },
        used_for_heating: { type: 'number', enum: [0, 1] },
        request: { type: ['string', 'null'] },
        system: { type: ['string', 'null'] },
        indoor_unit: { type: ['string', 'null'] },
        color: { type: ['string', 'null'] },
        connected_space: { type: ['string', 'null'] },
        spaces: { type: ['array', 'null'], items: { type: 'string' } },
        accessories: { type: ['array', 'null'], items: { type: 'string' } },
    },
    /**
     *  Error messages.
     */
    errorMessage: {
        properties: {
            name: 'De ruimte moet één naam hebben die bestaat uit letters',
            floor: 'Je bent vergeten een verdieping te kiezen',
            floor_description: 'Dit is helaas een ongeldige omschrijving',
            insulation_level: 'Je bent vergeten een isolatieniveau te kiezen',
            outdoor_unit_location: 'Je bent vergeten de locatie van de buitenunit te kiezen',
            length: '',
            width: '',
            height: '',
            contents: '',
        },
    },
    /**
     *  Conditional validation.
     */
    allOf: [
        /**
         *  Makes the floor description required if the
         *  floor "different" has been selected.
         */
        {
            if: {
                required: ['floor'],
                properties: {
                    floor: {
                        const: 'ccos-static-guid-floor-different-cco',
                    },
                },
            },
            then: {
                required: ['floor_description'],
                properties: {
                    floor_description: { type: 'string', pattern: "[a-z0-9\u00C0-\u00FF -'`’.,[\\]<>*\\/\":;|%#@$()!?^+_=]" },
                },
            },
        },
    ],
};
//# sourceMappingURL=space.schema.js.map